import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { ROLES } from 'config/constants'
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import { Edit, Delete, MoreVert, EventSeat, FileCopy } from '@material-ui/icons'
import history from '~/config/history'
import { ROUTES } from '~/views/routes'

export const SectorActionMenu = ({ sector, onDeleteSector }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { user } = useSelector((state) => state.login)
  const rolesArray = user?.roles?.split(',') || []
  const isAdminOrProducer =
    rolesArray?.includes(ROLES.ADMIN) || rolesArray?.includes(ROLES.PRODUCER)

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleEdit = () => {
    handleMenuClose()
    history.push(
      ROUTES.ADMIN.EVENTS.SECTORS.UPDATE.replace(':eventId', sector.EventId)
        .replace(':layoutId', sector.LayoutId)
        .replace(':sectorId', sector.Id)
    )
  }

  const handleClone = () => {
    handleMenuClose()
    history.push(
      ROUTES.ADMIN.EVENTS.SECTORS.CLONE.replace(':eventId', sector.EventId)
        .replace(':layoutId', sector.LayoutId)
        .replace(':sectorId', sector.Id)
    )
  }

  const handleDelete = () => {
    handleMenuClose()
    if (onDeleteSector) {
      onDeleteSector(sector)
    }
  }

  const handleSeatsDistribution = () => {
    handleMenuClose()
    history.push(
      ROUTES.ADMIN.EVENTS.SECTORS.SEATS.replace(':eventId', sector.EventId)
        .replace(':layoutId', sector.LayoutId)
        .replace(':sectorId', sector.Id)
    )
  }

  return (
    <>
      <IconButton size='small' onClick={handleMenuOpen}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <Edit fontSize='small' />
          </ListItemIcon>
          <ListItemText primary='Editar' />
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <ListItemIcon>
            <Delete fontSize='small' />
          </ListItemIcon>
          <ListItemText primary='Eliminar' />
        </MenuItem>
        <MenuItem onClick={handleClone}>
          <ListItemIcon>
            <FileCopy fontSize='small' />
          </ListItemIcon>
          <ListItemText primary='Clonar' />
        </MenuItem>
        {isAdminOrProducer && (
          <MenuItem onClick={handleSeatsDistribution}>
            <ListItemIcon>
              <EventSeat fontSize='small' />
            </ListItemIcon>
            <ListItemText primary='Dist. de Asientos' />
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default SectorActionMenu
